import styles from "./Steps.module.scss";
import Project_icon from "../../assets/images/steps/project_icon.svg";
import Done_icon from "../../assets/images/steps/done_icon.svg";
import Server_icon from "../../assets/images/steps/server_icon.svg";
import Online_icon from "../../assets/images/steps/online_icon.svg";
import Page from "../../assets/images/steps/page_not_found.svg";

export const Steps = () => {
  const {
    section__steps,
    wrapper__steps,
    steps__list,
    steps__item,
    steps__icon,
    steps__numb,
    steps__content,
    steps__title,
    steps__paragraph,
    steps__problems,
  } = styles;

  return (
    <section className={section__steps}>
      <div className={wrapper__steps}>
        <h2 className={steps__title} data-aos="fade-left" data-aos-delay="100">
          Zaloguj się do sieci w kilku prostych krokach
        </h2>
        <ul className={steps__list}>
          <li className={steps__item} data-aos="fade-up" data-aos-delay="200">
            <img className={steps__icon} src={Project_icon} alt="icon" />
            <span className={steps__numb}>1</span>
            <p className={steps__content}>Projekt graficzny</p>
          </li>
          <li className={steps__item} data-aos="fade-up" data-aos-delay="300">
            <img className={steps__icon} src={Done_icon} alt="icon" />
            <span className={steps__numb}>2</span>
            <p className={steps__content}>Wykonanie strony internetowej</p>
          </li>
          <li className={steps__item} data-aos="fade-up" data-aos-delay="400">
            <img className={steps__icon} src={Server_icon} alt="icon" />
            <span className={steps__numb}>3</span>
            <p className={steps__content}>Udostępnienie strony na serwerze</p>
          </li>
          <li className={steps__item} data-aos="fade-up" data-aos-delay="500">
            <img className={steps__icon} src={Online_icon} alt="icon" />
            <span className={steps__numb}>4</span>
            <p className={steps__content}>Jesteś ONLINE</p>
          </li>
        </ul>
        <div className={steps__problems}>
          <div>
            <img src={Page} alt="page_not_found" />
          </div>
          <div>
            <p className={steps__paragraph}>
              W dzisiejszych czasach, brak strony internetowej może znacząco
              utrudniać rozwój małych firm. Czy strona www jest potrzebna?
              Oczywiście! To podstawowy element marketingu, który pozwala
              wyróżnić się na tle konkurencji i dotrzeć do nowych klientów.
            </p>
            <p className={steps__paragraph}>
              {" "}
              Zastanawiasz się nad stworzeniem strony internetowej? Skontaktuj
              się ze mną
            </p>
          </div>
        </div>

        <div data-aos="fade-up" data-aos-delay="500">
          <button className="button">
            <a href="#contact">Zamów usługę</a>
          </button>
        </div>
      </div>
    </section>
  );
};
